import Header from 'modules/header/farm/main';
import {TARGET_URL} from 'services/config';
import useGetListFarms from 'utilities/hooks/listFarms';

const SelectFarm = () => {
  const {listFarms, loadingListFarms} = useGetListFarms();

  return (
    <>
      <Header title="انتخاب مزرعه" />
      <div className=" mt-6 px-4">
        {!loadingListFarms &&
          listFarms &&
          listFarms.results.reverse().map(item => (
            <p
              className=" my-2 text-gray-6 "
              key={item.id}
              onClick={() => {
                window.location.replace(
                  `${TARGET_URL}cultivation/addInputGroup/${item.guid}`,
                );
              }}
            >
              {item.name}
            </p>
          ))}
      </div>
    </>
  );
};

export default SelectFarm;
